<div class="d-flex flex-column flex-center flex-column-fluid p-10">
    <img src="assets/media/illustrations/sketchy/response.png" alt="error-404" class="mw-100 h-lg-350px h-xl-400px" />
    <h2 class="fw-bold mb-10 text-gray-600">{{ 'Global.NotFoundData' | translate }}</h2>
</div>
